import { render, staticRenderFns } from "./ContactOwnerUpdated.vue?vue&type=template&id=46736f0f&scoped=true"
import script from "./ContactOwnerUpdated.vue?vue&type=script&lang=js"
export * from "./ContactOwnerUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46736f0f",
  null
  
)

export default component.exports